// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetCardContent-Header_cls1__4YdxC","cls2":"VeloModalSheetCardContent-Header_cls2__tsQd2 VeloModalSheetCardContent-Header_cls1__4YdxC"};